import type {TicketTagDescriptionState} from 'store/slices/ticket/types';

import {Button, Loading} from '@ds/components';
import TagDescriptionFrame from 'common/ticketing-details/TagDescriptionFrame/TagDescriptionFrame';
import {useEffect, useState} from 'react';
import {useAppDispatch, useAppSelector} from 'store';
import {getTagDescription} from 'store/slices/ticket/thunk';

type TicketTagDescriptionProps = {tagId: number; vendorId: string | number};

const TicketTagDescription: React.FC<TicketTagDescriptionProps> = ({tagId, vendorId}) => {
  const dispatch = useAppDispatch();
  const description: TicketTagDescriptionState = useAppSelector(
    (state) => state.ticket.tagDescription
  );
  const [attempt, setAttempt] = useState(0);
  const [requestId, setRequestId] = useState<string | null>(null);

  useEffect(() => {
    const request = dispatch(getTagDescription({tag_id: tagId, vendor_id: vendorId}));
    setRequestId(request.requestId);
    return () => request.abort();
  }, [attempt, dispatch, tagId, vendorId]);

  const isCurrent =
    description.tagId === tagId &&
    description.vendorId === vendorId &&
    description.requestId === requestId;
  const html = isCurrent ? description.html : null;

  if (!isCurrent || description.loading) {
    return (
      <div className="flex justify-center p-5" role="status" aria-label="دریافت راهنمای موضوع">
        <Loading />
      </div>
    );
  }

  if (description.error) {
    return (
      <div className="flex flex-col gap-2 px-5" role="alert">
        <p className="text-body-sm text-gray-08">دریافت راهنمای موضوع با خطا مواجه شد.</p>
        <Button variant="outline" onClick={() => setAttempt((value) => value + 1)}>
          تلاش مجدد
        </Button>
      </div>
    );
  }

  if (!html?.trim()) return null;

  return <TagDescriptionFrame html={html} />;
};

export default TicketTagDescription;
